import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=3002e850&scoped=true"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=3002e850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002e850",
  null
  
)

export default component.exports